import fwUtil from 'framework-util'

const sentimentWebsiteService = new fwUtil.ApiService.ApiService('sentimentWebsite');

export { sentimentWebsiteService }

export { sentimentTotalService }
  export function getSentimentWebsiteByDate(data){
    return custemRequest({
      url: 'sentimentWebsite/list/byDay',
      method: 'get',
      params: data
    })
  }


// WEBPACK FOOTER //
// ./src/api/pubsentiment/sentimentWebsite.js